interface Date {
	toFormatString(this: Date, formato: string): string;
	addMonth(this: Date, months: number): Date;
	monthDiff(dateDesde: Date, dateHasta: Date): number;
	toLocaleISOString(this: Date): string;
	fromNumber(number: number): Date;
}
interface String {
	toDate(this: string): Date;
	toDateTime(this: string): Date;
}

Date.prototype.addMonth = function (this: Date, months: number): Date {
	var year = this.getFullYear();
	var month = this.getMonth();
	year += Math.trunc(months / 12);
	month += months % 12;
	return new Date(this.setFullYear(year, month));
};

Date.prototype.monthDiff = function (dateDesde: Date, dateHasta: Date) {
	var months;
	months = (dateHasta.getFullYear() - dateDesde.getFullYear()) * 12;
	months -= dateDesde.getMonth();
	months += dateHasta.getMonth();
	return months <= 0 ? 0 : months;
};

Date.prototype.toLocaleISOString = function (this: Date) {
	return new Date(
		this.getTime() - this.getTimezoneOffset() * 60000
	).toISOString();
};

Date.prototype.toFormatString = function (this: Date, formato: string): string {
	var resultado = '';

	var aaaa: string = this.getFullYear().toString();
	var mm: string = (this.getMonth() + 1).toString().padStart(2, '0');
	var dd: string = this.getDate().toString().padStart(2, '0');
	//permito usar yyyy
	formato = formato.replace('yyyy', 'aaaa');
	formato = formato.toLowerCase();
	var formatos = [
		'aaaammdd',
		'aaaa-mm-dd',
		'aaaa-dd-mm',
		'dd-mm-aaaa',
		'dd-aaaa-mm',
		'mm-dd-aaaa',
		'mm-aaaa-dd',

		'aaaa/mm/dd',
		'aaaa/dd/mm',
		'dd/mm/aaaa',
		'dd/aaaa/mm',
		'mm/dd/aaaa',
		'mm/aaaa/dd',

		'aaaa.mm.dd',
		'aaaa.dd.mm',
		'dd.mm.aaaa',
		'dd.aaaa.mm',
		'mm.dd.aaaa',
		'mm.aaaa.dd',
	];

	if (formatos.includes(formato)) {
		resultado = formato.replace('aaaa', aaaa);
		resultado = resultado.replace('mm', mm);
		resultado = resultado.replace('dd', dd);
	} else {
		throw new Error('Formato no valido');
	}
	return resultado;
};

String.prototype.toDate = function (this: string): Date {
	return new Date(this.substring(0, 10) + 'T00:00:00');
};

String.prototype.toDateTime = function (this: string): Date {
	return new Date();
};

Date.prototype.fromNumber = function (fechaNumber: number) {
	// Tomo la parte entera de la division, quedandome como resultado el año
	// Por ej 20160106 / 10000 --> 2016,0106
	let año = Math.trunc(fechaNumber / 10000);
	// Lo mismo para sacar el mes, tomo la parte entera de una operacion
	// Por ej (20160106 - (2016*1000))/100 --> 106/100 --> 1,06
	let mes = Math.trunc((fechaNumber - año * 10000) / 100);
	let dia = fechaNumber - Math.trunc(fechaNumber / 100) * 100;
	let fechaDate = new Date();

	// Mes -1 porque 0 es enero, si queda numero negativo el metodo resuelve, seteando un año anterior y el mes q corresponda
	fechaDate.setFullYear(año, mes - 1, dia);
	return fechaDate;
};
